// Formats partagés du cockpit /admin/analytics. Heures affichées à l'heure de Paris.

const TZ = 'Europe/Paris';

/** 45 s · 2 min 14 s · 1 h 03 min. null → « — » (durée inconnue). */
export function formatStay(ms) {
  if (ms === null || ms === undefined || !Number.isFinite(Number(ms))) return '—';
  const total = Math.round(Number(ms) / 1000);
  if (total < 1) return '< 1 s';
  if (total < 60) return `${total} s`;
  const minutes = Math.floor(total / 60);
  if (minutes < 60) return `${minutes} min ${String(total % 60).padStart(2, '0')} s`;
  return `${Math.floor(minutes / 60)} h ${String(minutes % 60).padStart(2, '0')} min`;
}

/** Position dans une vidéo ou un replay : 75 000 → « 1:15 ». */
export function clock(ms) {
  const total = Math.max(0, Math.floor((Number(ms) || 0) / 1000));
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`;
}

function parisDay(ts) {
  return new Intl.DateTimeFormat('fr-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(ts));
}

/** « 14:02 » aujourd'hui, « hier 14:02 », sinon « 3 oct. 14:02 ». */
export function when(ts) {
  if (!ts) return '—';
  const time = new Date(ts).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', timeZone: TZ });
  const day = parisDay(ts);
  if (day === parisDay(Date.now())) return time;
  if (day === parisDay(Date.now() - 24 * 3600e3)) return `hier ${time}`;
  const date = new Date(ts).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', timeZone: TZ });
  return `${date} ${time}`;
}

export function fullDate(ts) {
  if (!ts) return '';
  return new Date(ts).toLocaleString('fr-FR', { day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit', timeZone: TZ });
}

export function money(cents, currency) {
  const amount = (Number(cents) || 0) / 100;
  const shown = Number.isInteger(amount) ? String(amount) : amount.toFixed(2).replace('.', ',');
  if (currency === 'usd') return `$${shown}`;
  if (currency === 'cad') return `${shown} $ CA`;
  if (currency === 'eur') return `${shown} €`;
  return `${shown} ${String(currency || '').toUpperCase()}`;
}

export function rate(part, total) {
  if (!total) return '—';
  return `${Math.round((part / total) * 100)} %`;
}

export function flag(country) {
  const code = String(country || '').toUpperCase();
  if (!/^[A-Z]{2}$/.test(code)) return '';
  return String.fromCodePoint(...[...code].map((c) => 127397 + c.charCodeAt(0)));
}

export function place(person) {
  return [person.city, person.country].filter(Boolean).join(', ') || 'Lieu inconnu';
}

export const SECTION_LABEL = {
  hero: 'Haut de page',
  'film-top': 'Vidéo',
  film: 'Vidéo',
  verite: 'Vérité',
  resultats: 'Résultats',
  chemins: 'Deux chemins',
  methode: 'Méthode',
  appel: 'Appel',
  formations: 'Formations',
  bros: 'Groupe',
  campus: 'Espace membre',
  mentor: 'Mentor',
  prix: 'Prix',
  faq: 'FAQ',
};

export function sectionName(id) {
  return SECTION_LABEL[id] || id || '';
}

export const STEP_LABEL = { visit: 'Arrivé', join: 'Clic rejoindre', checkout: 'Checkout ouvert', paid: 'Payé' };

export const VIDEO_SHORT = {
  'film-fr': 'Film FR',
  'film-en': 'Film EN',
  smoothie: 'HS 04',
  taco: 'HS 03',
  burger: 'HS 01',
  pizza: 'HS 02',
  bites: 'HS 05',
  pancakes: 'High secret',
};
